<template>
  <div class="provider-label" :class="{ blocked: isBlocked }">
    <p class="name bold">{{ label }}</p>
    <p class="services ls-radios--sub-label">{{ subLabel }}</p>

    <LsInfoCard v-if="isBlocked" class="no-margin">
      <h4>CANNOT CHANGE PRO</h4>
      <p v-if="bundle.isBlockedByReturnRequest">{{ returnRequestText }}</p>
      <p v-if="bundle.isBlockedByDistribution">{{ distributionText }}</p>
      <p v-if="bundle.isBlockedByOneTimeReschedule">{{ oneTimeRescheduleText }}</p>
    </LsInfoCard>
  </div>
</template>

<script>
import VueTypes from 'vue-types';
import { LsInfoCard } from '@/components/common';

export default {
  name: 'ProviderRadioLabel',
  components: { LsInfoCard },
  props: {
    label: VueTypes.string.isRequired,
    subLabel: VueTypes.string.isRequired,
    bundle: VueTypes.shape({
      isBlockedByReturnRequest: VueTypes.bool.def(false),
      isBlockedByOneTimeReschedule: VueTypes.bool.def(false),
      isBlockedByDistribution: VueTypes.bool.def(false),
    }),
  },
  data() {
    return {
      returnRequestText:
        'It looks like you requested to have your pro return to fix an issue with your service. While that request is in progress, we are unable to change your pro.',
      oneTimeRescheduleText:
        'It looks like you already requested a one-time reschedule for this service. While this request is in progress, we are unable to change your pro.',
      distributionText:
        'We are already working on finding a new pro to service your lawn care needs. While this change is in progress, we are unable to accept a request to change pros. You will be notified when a new pro is assigned.',
    };
  },
  computed: {
    isBlocked() {
      return (
        this.bundle.isBlockedByReturnRequest ||
        this.bundle.isBlockedByOneTimeReschedule ||
        this.bundle.isBlockedByDistribution
      );
    },
  },
};
</script>

<style lang="scss" scoped>
@media (min-width: $desktop) {
  .provider-label {
    .info-card {
      margin: 2rem 0 0rem 0 !important;
    }
  }
}

.provider-label {
  .name {
    font-weight: 600;
    text-transform: capitalize;
  }

  .services {
    font-weight: 400;
  }

  .info-card {
    margin: 4rem 0 0 0;
    padding: 2rem 2rem 2rem 4rem;

    h4 {
      font-weight: 700;
      margin-bottom: 2px;
    }
  }

  &.blocked {
    .name,
    .services {
      color: $theme-color-gray-dark;
    }
  }
}
</style>
